"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Page;
var _react = require("react");
var _CellWrapper = _interopRequireDefault(require("./CellWrapper"));
var _index = require("./index");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Page({
  page,
  screenSize,
  project,
  logEvent,
  device_id,
  project_id,
  uri_transformer = url => url
}) {
  const [selectedProduct, setSelectedProduct] = (0, _react.useState)(null);
  const [menuCellConfig, setMenuCellConfig] = (0, _react.useState)({
    template_name: 'default',
    styles_properties: {}
  });
  // L'éditeur utilise un canvas de (ratio_x * 50) x (ratio_y * 50) pixels
  // Il faut convertir vers les dimensions réelles de l'écran
  const BASE_SIZE = 50;

  // Calculer le facteur de conversion
  const getScaleFactor = () => {
    if (!project?.screen_size) return 1;
    const editorWidth = project.screen_size.ratio_x * BASE_SIZE;
    const realWidth = screenSize?.width || project.screen_size.width;
    return realWidth / editorWidth;
  };
  const scaleFactor = getScaleFactor();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "page",
      style: {
        width: screenSize?.width,
        height: screenSize?.height,
        position: 'relative',
        backgroundColor: page.background_type === 'color' ? page.background_color : '#ffffff',
        backgroundImage: page.background_type === 'image' ? `url(${page.background_image_uri})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      },
      children: page.cells?.map(cell => /*#__PURE__*/(0, _jsxRuntime.jsx)(Cell, {
        cell: cell,
        scaleFactor: scaleFactor,
        project: project,
        logEvent: logEvent,
        device_id: device_id,
        project_id: project_id,
        uri_transformer: uri_transformer,
        onProductClick: (product, config) => {
          setSelectedProduct(product);
          if (config) {
            setMenuCellConfig(config);
          }
        }
      }, cell.id))
    }), selectedProduct && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ProductDetailModal, {
      product: selectedProduct,
      onClose: () => setSelectedProduct(null),
      uri_transformer: uri_transformer,
      template_name: menuCellConfig.template_name,
      styles_properties: menuCellConfig.styles_properties
    })]
  });
}
function Cell({
  cell,
  scaleFactor,
  logEvent,
  device_id,
  project_id,
  uri_transformer,
  project,
  onProductClick
}) {
  // Appliquer le facteur de conversion aux positions et tailles
  const cellStyle = {
    position: 'absolute',
    left: `${(cell.position_x || 0) * scaleFactor}px`,
    top: `${(cell.position_y || 0) * scaleFactor}px`,
    width: `${(cell.size_x || 200) * scaleFactor}px`,
    height: `${(cell.size_y || 100) * scaleFactor}px`,
    zIndex: cell.index || 0
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: cellStyle,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CellWrapper.default, {
      ...cell,
      logEvent: logEvent,
      device_id: device_id,
      project_id: project_id,
      children: [cell.type === 'text' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.TextCell, {
        ...cell,
        scaleFactor: scaleFactor
      }), cell.type === 'image' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ImageCell, {
        ...cell,
        uri_transformer: uri_transformer
      }), cell.type === 'video' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.VideoCell, {
        ...cell,
        uri_transformer: uri_transformer
      }), cell.type === 'button' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ButtonCell, {
        ...cell,
        scaleFactor: scaleFactor
      }), cell.type === 'form' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.FormCell, {
        ...cell,
        scaleFactor: scaleFactor
      }), cell.type === 'carousel' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.CarouselCell, {
        ...cell,
        uri_transformer: uri_transformer,
        scaleFactor: scaleFactor
      }), cell.type === 'iframe' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.IframeCell, {
        ...cell
      }), cell.type === 'header' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.HeaderCell, {
        ...cell,
        scaleFactor: scaleFactor
      }), cell.type === 'html' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.HtmlCell, {
        ...cell,
        scaleFactor: scaleFactor
      }), cell.type === 'menu' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.MenuCell, {
        scaleFactor: scaleFactor,
        ...cell,
        logEvent: logEvent,
        device_id: device_id,
        project_id: project_id,
        products: project?.products || [],
        onProductClick: product => onProductClick(product, {
          template_name: cell.template_name,
          styles_properties: cell.styles_properties
        }),
        uri_transformer: uri_transformer
      }), cell.type === 'scheduled' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ScheduleCell, {
        scaleFactor: scaleFactor,
        ...cell
      }), cell.type === 'clock' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ClockCell, {
        ...cell,
        scaleFactor: scaleFactor
      }), cell.type === 'pluracore' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.PluracoreCell, {
        scaleFactor: scaleFactor,
        ...cell
      }), cell.type === 'review' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ReviewCell, {
        scaleFactor: scaleFactor,
        ...cell
      }), cell.type === 'map' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.MapCell, {
        scaleFactor: scaleFactor,
        ...cell
      }), (cell.type === 'command' || cell.type === 'commands') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.CommandCell, {
        ...cell,
        logEvent: logEvent,
        device_id: device_id,
        project_id: project_id,
        scaleFactor: scaleFactor,
        products: project?.products || [],
        uri_transformer: uri_transformer
      })]
    })
  });
}